/**
 * Slug and name for every role guide, and nothing else.
 *
 * The footer links to all of them from every page, and the router needs the
 * slugs at build time. Importing ROLE_GUIDES for that pulled the whole content
 * file — 56 kB of before/after bullets, FAQs and keyword lists — into the entry
 * chunk, so every visitor downloaded all twelve guides to render twelve links.
 *
 * role-guides.ts stays the source of truth. role-guide-links.test.ts fails if
 * this list drifts from it, which is the only thing holding the two together.
 */
export const ROLE_GUIDE_LINKS: Array<{ slug: string; name: string }> = [
  { slug: "software-engineer", name: "Software Engineer" },
  { slug: "frontend-developer", name: "Frontend Developer" },
  { slug: "backend-developer", name: "Backend Developer" },
  { slug: "full-stack-developer", name: "Full Stack Developer" },
  { slug: "data-analyst", name: "Data Analyst" },
  { slug: "data-scientist", name: "Data Scientist" },
  { slug: "devops-engineer", name: "DevOps Engineer" },
  { slug: "product-manager", name: "Product Manager" },
  { slug: "qa-engineer", name: "QA Engineer" },
  { slug: "machine-learning-engineer", name: "Machine Learning Engineer" },
  { slug: "mobile-developer", name: "Mobile Developer" },
  { slug: "ui-ux-designer", name: "UI/UX Designer" },
];
